import { Download, Plus } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/shared/components/ui/button'

import CreateQuoteDialog from './CreateQuoteDialog'

export default function QuoteHeader({ onExport }) {
  const [open, setOpen] = useState(false)

  return (
    <div className="rounded-3xl border bg-white p-7 shadow-sm">
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-3xl font-bold">Quotes</h1>

          <p className="mt-2 text-muted-foreground">
            Generate proforma invoices and push accepted quotes to Tally.
          </p>
        </div>

        <div className="flex items-center gap-2">
          {/* Create Quote button before Export button */}
          <Button
            onClick={() => setOpen(true)}
            className="rounded-full bg-[#0F172A] px-6 text-white shadow-sm hover:bg-[#1E293B]"
          >
            <Plus className="mr-2 h-4 w-4" />
            Create Quote
          </Button>

          <Button
            variant="outline"
            onClick={onExport}
            className="rounded-full px-6 shadow-sm"
          >
            <Download className="mr-2 h-4 w-4" />
            Export
          </Button>
        </div>
      </div>

      {/* Modal with lead selector */}
      <CreateQuoteDialog open={open} onOpenChange={setOpen} />
    </div>
  )
}
